import React from "react";
import { Modal, Button } from "antd";
import "./LdsPriceChangeConfirmModal.css";

function formatIls(value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  try {
    return new Intl.NumberFormat("he-IL", {
      style: "currency",
      currency: "ILS",
      maximumFractionDigits: 0,
    }).format(Number(value));
  } catch {
    return `₪${Math.round(Number(value))}`;
  }
}

function formatBase(value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  return Number(value).toLocaleString("he-IL", { maximumFractionDigits: 2 });
}

/**
 * Hebrew confirmation dialog for LDS FlightsHotel PRICE_CHANGED (P2 Staging).
 */
export default function LdsPriceChangeConfirmModal({
  open = false,
  payload = null,
  confirming = false,
  onConfirm,
  onCancel,
}) {
  if (!payload) return null;

  const sellOld = payload.sell_price_old;
  const sellNew = payload.sell_price_new;
  const sellDelta =
    payload.sell_delta != null
      ? Number(payload.sell_delta)
      : sellOld != null && sellNew != null
        ? Number(sellNew) - Number(sellOld)
        : null;
  const baseOld = payload.base_fare_old;
  const baseNew = payload.base_fare_new;
  const remainingNew = payload.remaining_new;
  const paid = payload.amount_already_paid;

  const deltaLabel =
    sellDelta == null
      ? "—"
      : `${sellDelta > 0 ? "+" : ""}${formatIls(sellDelta)}`;

  return (
    <Modal
      open={open}
      onCancel={confirming ? undefined : onCancel}
      footer={null}
      centered
      width={560}
      className="lds-price-change-modal"
      title="מחיר החבילה עודכן מול הספק"
      maskClosable={!confirming}
      closable={!confirming}
    >
      <div className="lds-price-change-modal__body" dir="rtl">
        <p className="lds-price-change-modal__lead">
          {payload.message_he ||
            payload.message ||
            "מחיר הבסיס השתנה. יש לאשר את המחיר החדש לפני יצירת קישור תשלום."}
        </p>

        <div className="lds-price-change-modal__grid">
          <div>
            <span className="lds-price-change-modal__label">מחיר מכירה קודם</span>
            <div className="lds-price-change-modal__value" dir="ltr">
              {formatIls(sellOld)}
            </div>
          </div>
          <div>
            <span className="lds-price-change-modal__label">מחיר מכירה חדש</span>
            <div
              className="lds-price-change-modal__value lds-price-change-modal__value--new"
              dir="ltr"
            >
              {formatIls(sellNew)}
            </div>
          </div>
          <div>
            <span className="lds-price-change-modal__label">הפרש</span>
            <div className="lds-price-change-modal__value" dir="ltr">
              {deltaLabel}
            </div>
          </div>
        </div>

        <div className="lds-price-change-modal__meta-row">
          <span>
            בסיס ספק: {formatBase(baseOld)} → {formatBase(baseNew)}
          </span>
          {paid != null && Number(paid) > 0 ? (
            <span>שולם עד כה: {formatIls(paid)}</span>
          ) : null}
          {remainingNew != null ? (
            <span>יתרה לתשלום: {formatIls(remainingNew)}</span>
          ) : null}
        </div>

        <div className="lds-price-change-modal__actions">
          <Button type="primary" loading={confirming} onClick={onConfirm}>
            אשר מחיר חדש והמשך לתשלום
          </Button>
          <Button disabled={confirming} onClick={onCancel}>
            ביטול
          </Button>
        </div>
      </div>
    </Modal>
  );
}
